<script>
import EventBus from '@/js/util/EventBus'
import tag from '@/js/util/props/tag'
import modalId from '@/js/util/props/modalId'

import ModalContainerDialog from './ModalContainerDialog'

export default {
  provide() {
    return { modal: this }
  },
  props: {
    ...tag,
    ...modalId,

    mode: {
      type: String,
      default: 'show',
      validator: mode => [
        'if',
        'show',
      ].includes(mode),
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      expanded: false,
      modalDialog: undefined,
    }
  },

  created() {
    EventBus.$on('toggle:modal', this.maybeToggleModal)
  },
  mounted() {
    if (this.initiallyExpanded) {
      this.toggleModal()
    }
  },

  methods: {
    maybeToggleModal(buttonId) {
      if (buttonId !== this.modalId) {
        return
      }
      this.toggleModal()
    },

    toggleModal() {
      const { expanded } = this

      this.expanded = !expanded
      // this.lockBody()

      // <ModalContainer
      //   @modal-open="doOpenThing"
      //   @modal-close="doCloseThing"
      // >
      //   modal content
      // </ModalContainer>
      this.$emit(`modal-${expanded ? 'open' : 'close'}`)
    },

    lockBody() {
      if (this.expanded) {
        document.body.classList.add('locked')
      } else {
        document.body.classList.remove('locked')
      }
    },

    createsFocusTrap(createElement, position) {
      return createElement('div', {
        attrs: { tabindex: 0 },
        on: { focus: () => this.modalDialog.$emit(`focus-${position}-descendant`) },
      })
    },

    createsModalButton(createElement) {
      const { modalButton } = this.$slots
      const elementData = {
        class: 'ModalButton--close',
        props: { modalId: this.modalId },
      }
      return modalButton
        ? createElement('ModalButton', elementData, modalButton)
        : undefined
    },

    createsModalDialog(createElement) {
      const modalDialog = createElement(ModalContainerDialog, {
        on: {
          createsModalDialog: (dialog) => {
            this.modalDialog = dialog
          },
        },
      }, this.$slots.default)

      return [
        this.createsFocusTrap(createElement, 'first'),
        // optional named slot for ModalButton
        // passing the ModalButton through this slot
        // renders the ModalButton outside of the dialog
        // for different DOM structure
        this.createsModalButton(createElement),
        modalDialog,
        this.createsFocusTrap(createElement, 'last'),
      ]
    },
  },

  render(createElement) {
    const elementData = {
      staticClass: 'ModalContainer',
      on: {
        keyup: ({ keyCode }) => {
          if (keyCode !== 27) {
            return
          }

          this.toggleModal()
        },
      },
    }

    const { expanded, mode } = this

    if (mode === 'show') {
      elementData.directives = [{
        name: 'show',
        value: expanded,
      }]
    }

    const modalOverlay = createElement('div', {
      staticClass: 'ModalContainer__overlay',
      on: { click: () => EventBus.$emit('toggle:modal', this.modalId) },
    })
    const modalDialog = this.createsModalDialog(createElement)

    return mode === 'show' || expanded
      ? createElement(this.tag, elementData, [modalOverlay, modalDialog])
      : undefined
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/modal/ModalContainer.vue